import { render, staticRenderFns } from "./Pooldetail.vue?vue&type=template&id=e4ffb6f6&scoped=true"
import script from "./Pooldetail.vue?vue&type=script&lang=js"
export * from "./Pooldetail.vue?vue&type=script&lang=js"
import style0 from "./Pooldetail.vue?vue&type=style&index=0&id=e4ffb6f6&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ffb6f6",
  null
  
)

export default component.exports